<div id="captureArea">
    <ng-container *ngIf="mdsCodeValue(); else loaderTemplate">
        <bnpp-indx-index-headerinfo [mdsCode]="mdsCodeValue()"></bnpp-indx-index-headerinfo>
        <bnpp-indx-index-keyinfo [mdsCode]="mdsCodeValue()"></bnpp-indx-index-keyinfo>
        <bnpp-indx-index-perfriskinfo [mdsCode]="mdsCodeValue()"></bnpp-indx-index-perfriskinfo>
        <bnpp-indx-index-performancechart [mdsCode]="mdsCodeValue()"></bnpp-indx-index-performancechart>
        <bnpp-indx-index-footer [mdsCode]="mdsCodeValue()"></bnpp-indx-index-footer>
    </ng-container>
    <ng-template #loaderTemplate>
        <div class="fixed inset-0 bg-white opacity-50 flex items-center justify-center z-50">
            <p-progressSpinner styleClass="w-16 h-16" strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
        </div>
    </ng-template>
</div>